export const YES = 'Yes';
export const NO = 'No';
export const NA = 'N/A';

export const LEFT = 'left';
export const RIGHT = 'right';
